import { render, staticRenderFns } from "./Specification.vue?vue&type=template&id=0133ef91&scoped=true"
import script from "./Specification.vue?vue&type=script&lang=js"
export * from "./Specification.vue?vue&type=script&lang=js"
import style0 from "./Specification.vue?vue&type=style&index=0&id=0133ef91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0133ef91",
  null
  
)

export default component.exports